<template lang="html">
  <transition name="scale">
    <div class="preview-box" v-show="isShow">
      <div class="mask" @click="close"></div>
      <div class="img-box">
        <img :src="imgUrl" alt="">
      </div>
    </div>
  </transition>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
export default {
  computed: {
    ...mapGetters(['imgUrl', 'isShow'])
  },
  methods: {
    close () {
      this.setShow(false)
    },
    ...mapMutations({
      setShow: 'SET_IS_SHOW'
    })
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.scale-enter-active, .scale-leave-active
    transition: all 0.3s
.scale-enter, .scale-leave-to
    opacity: 0
.preview-box
  width: 100%
  height: 100%
  position: fixed
  left: 0
  top: 0
  bottom: 0
  right: 0
  z-index: 9999
  .mask
    width: 100%
    height: 100%
    position: absolute
    left: 0
    top: 0
    right: 0
    bottom: 0
    cursor: pointer
    background-color: rgba(0, 0, 0, 0.7)
  .img-box
    width: 400px
    height: 400px
    position: absolute
    left: 50%
    top: 50%
    margin: -200px 0 0 -200px
    background-color: #fff
    img
      width: 100%
      height: 100%
@media (max-width: 1200px)
  .img-box
    width: 200px !important
    height: 200px !important
    margin: -100px 0 0 -100px !important
</style>



// WEBPACK FOOTER //
// src/base/preview/preview.vue